import { Button as BaseButton } from "@base-ui/react/button";
import { cva, type VariantProps } from "class-variance-authority";
import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...values: ClassValue[]) {
  return twMerge(clsx(values));
}

export const buttonVariants = cva(
  "inline-flex shrink-0 items-center justify-center gap-2 rounded-lg border text-[13px] leading-tight font-medium whitespace-nowrap no-underline transition-[color,background-color,filter] disabled:pointer-events-none disabled:opacity-50 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-brand [&_svg]:pointer-events-none [&_svg]:shrink-0 motion-reduce:transition-none",
  {
    variants: {
      variant: {
        default:
          "border-ink bg-ink text-white shadow-chip-dark hover:brightness-125 active:translate-y-px",
        secondary:
          "border-black/10 bg-card text-ink shadow-chip hover:bg-white/80",
        ghost:
          "border-transparent bg-transparent text-ink shadow-none hover:bg-black/5",
      },
      size: { default: "min-h-8 px-3 py-1.5", icon: "size-8 p-1.5" },
    },
    defaultVariants: { variant: "default", size: "default" },
  },
);
export function Button({
  className,
  variant,
  size,
  ...props
}: BaseButton.Props & VariantProps<typeof buttonVariants>) {
  return (
    <BaseButton
      data-slot="button"
      className={cn(buttonVariants({ variant, size }), className)}
      {...props}
    />
  );
}
